exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".image-uploader,.image-uploader .el-upload,.image-uploader .el-upload-dragger{width:100%}", "", {"version":3,"sources":["/Users/yuki/Public/wp-admin/src/components/routes/MediaUpload.vue"],"names":[],"mappings":"AAIA,8EAEI,UAAY,CACf","file":"MediaUpload.vue","sourcesContent":["\n.image-uploader {\n  width: 100%;\n}\n.image-uploader .el-upload,\n  .image-uploader .el-upload-dragger {\n    width: 100%;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-a180f8ac","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/routes/MediaUpload.vue
// module id = 838
// module chunks = 9